import { useAppSelector } from "@/redux/store.ts";
import { SmartNumberDescriptor, type SmartNumberDescriptorKey } from "@/types";

const EXCLUDED_PRODUCT_REFERENCE_DESCRIPTORS = new Set<SmartNumberDescriptorKey>([
    SmartNumberDescriptor.MountingKit,
    SmartNumberDescriptor.PowerSupply,
]);

export default function useProductReference(): string | null {
    const smartNumber = useAppSelector((state) => state.smartNumber.calculatedResult);
    const description = useAppSelector((state) => state.smartNumber.description);

    if (!smartNumber || description.length === 0) return null;

    let offset = 0;
    let reference = "";

    for (const definition of description) {
        const length = Number(definition.CharacteristicLength);
        if (!Number.isInteger(length) || length < 0) return null;

        const part = smartNumber.slice(offset, offset + length);
        offset += length;

        // Consume every part so exclusions do not shift subsequent values.
        if (!EXCLUDED_PRODUCT_REFERENCE_DESCRIPTORS.has(definition.CharacteristicName)) {
            reference += part;
        }
    }

    return reference;
}
